import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClassProvider, FactoryProvider } from '@angular/core';


import { DevToolsService } from 'ib/internetbank-core/dev-tools/dev-tools.service';

import { environment } from '../../../environments/environment';

import { AuthInterceptor } from './auth-interseptor';
import { CoreHttpInterceptor } from './core-http.interceptor';

const coreHttpInterceptorFactory = (devToolsService: DevToolsService): CoreHttpInterceptor => {
	if (environment.production) {
		return new CoreHttpInterceptor(undefined);
	} else {
		return new CoreHttpInterceptor((url: string): string => {
			return devToolsService.getRestSegment(url);
		});
	}
};

export const HttpInterceptors: Array<FactoryProvider | ClassProvider> = [
	// перехват ошибок и выброс исключений
	{
		provide: HTTP_INTERCEPTORS,
		useFactory: coreHttpInterceptorFactory,
		multi: true,
		deps: [DevToolsService],
	},
	// работа с авторизацией пользователя
	{
		provide: HTTP_INTERCEPTORS,
		useClass: AuthInterceptor,
		multi: true,
	},
];
